import { userList } from "../../../basic/path";
import RequestModel from "../../../basic/requestConfig";
import { isExpired } from "../../../basic/response";

export default {
  updateSubscription(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
        method: "post",
        url: userList.updateSubscription,
        data: query.data ? query.data : {},
        params: query.params ? query.params : {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      });
      let request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  deleteUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
        method: "post",
        url: userList.delUser,
        data: query.data ? query.data : {},
        params: query.params ? query.params : {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      });
      let request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  checkUserExistence(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
        method: "get",
        url: userList.checkUserExistence,
        data: query.data ? query.data : {},
        params: query.params ? query.params : {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      });
      let request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  addExistingUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
        method: "post",
        url: userList.addExistingUser,
        data: query.data ? query.data : {},
        params: query.params ? query.params : {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      });
      let request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getSubscriptionList(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
        method: "get",
        url: userList.getSubscriptionList,
        data: query.data ? query.data : {},
        params: query.params ? query.params : {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      });
      let request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  addUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: userList.addUser,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  disableUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: userList.disableUser,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  updUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: userList.updUser,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  queryAllUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: userList.queryAllUser,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  queryRoles(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: userList.queryRoles,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getUser(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: userList.getUser,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  updPwd(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: userList.updPwd,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  updTimezone(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: userList.updTimezone,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
};
